// Scroll to the top of the page whenever the pathname changes.
// Also handles the AppShell's <main> container so content scroll resets too.
import { useEffect } from "react";
import { useLocation } from "react-router-dom";

export default function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => {
    // Reset window scroll — covers desktop layouts where the page scrolls
    if (typeof window !== "undefined") {
      window.scrollTo({ top: 0, left: 0, behavior: "instant" in window ? "instant" : "auto" });
    }
    // Reset scroll on any inner scroll container (e.g. AppShell <main>)
    document
      .querySelectorAll("[data-scroll-container='true']")
      .forEach((el) => {
        el.scrollTop = 0;
      });
  }, [pathname]);
  return null;
}
